var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main container" },
    [
      !_vm.isLoading
        ? _c("div", { staticClass: "title-header" }, [
            _c("div", { staticClass: "row title-container" }, [
              _c("div", { staticClass: "col-auto" }, [
                _c("div", { staticClass: "title-header-text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.CONSTANTS.IT_SERVICE_DIRECTORY) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-auto px-lg-0" },
                [
                  _c("employee-hub-bookmark", {
                    staticClass: "d-inline-block",
                    attrs: {
                      title: _vm.CONSTANTS.IT_SERVICE_DIRECTORY,
                      "show-circle": ""
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading || _vm.isServicesByRoleLoading
        ? _c("loading-overlay")
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "services-panel" },
                  _vm._l(_vm.servicePlatforms, function(
                    servicePlatform,
                    index
                  ) {
                    return !_vm.isServicesByRoleLoading
                      ? _c("service-directory-platform", {
                          key: index,
                          attrs: {
                            name: servicePlatform.name,
                            serviceAreas: servicePlatform.serviceAreas
                          },
                          on: {
                            handleClickServiceModal: _vm.handleClickServiceModal
                          }
                        })
                      : _vm._e()
                  }),
                  1
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a8271e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a8271e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-directory/ServiceDirectory.vue
// module id = null
// module chunks = 